/**
 * ErrorPage Component
 * 
 * 500 error page shown for server errors.
 */

import { useNavigate } from 'react-router-dom'
import { Home, AlertCircle } from 'lucide-react'
import { Button } from '../../components/ui/button'
import { Card, CardContent } from '../../components/ui/card'

const ErrorPage = ({ message }) => {
  const navigate = useNavigate()

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        <CardContent className="pt-12 pb-8">
          <AlertCircle className="h-16 w-16 mx-auto text-destructive mb-4" />

          <h1 className="text-4xl font-bold text-destructive mb-2">Error 500</h1>

          <p className="text-muted-foreground mb-6">
            {message || 'An internal server error occurred. Please try again later.'}
          </p>

          <Button onClick={() => navigate('/')}>
            <Home className="h-4 w-4 mr-2" />
            Go Home
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default ErrorPage